import slice, { entityAdapter } from './slice';
import * as _selectors from './selectors';
export { epics } from './epics';

export const selectors = { ..._selectors, ...entityAdapter.getSelectors() };
export const actions = slice.actions;
export const reducer = slice.reducer;
